import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.objectsSuggested(), {
    params: query,
    paramsSerializer: (params) => serializeStrapiParams(params).join('&'),
  });
  return data;
};

const findOne = async (id) => {
  const { data } = await axiosInstance.get(endpoints.objectsSuggested(id));
  return data;
};

const create = async (data) => {
  const { data: object } = await axiosInstance.post(endpoints.objectsSuggested(), {data});
  return object;
};

const update = async (id, data) => {
  const { data: object } = await axiosInstance.put(endpoints.objectsSuggested(id), {data});
  return object;
};

const remove = async (id) => {
  const { data: object } = await axiosInstance.delete(endpoints.objectsSuggested(id));
  return object;
};

const accept = async (id) => {
  const { data } = await axiosInstance.post(endpoints.objectSuggestedAccept(id));
  return data;
};

const client = { find, findOne, create, update, remove, accept };

export default client;
